import html from "./WebViewStep.html"
import webViewContent from "./WebViewContent.html"
import webViewStructuredHtml from "./WebViewStructuredHtml.html"
import "../../MyDataHelps/Views/ProviderAccountService.js"
import "../../MyDataHelps/ParticipantDeviceInfoService.js"
import appActionHandler from "../../../helpers/appActionHandler";
import { makeCssVars } from "../../../helpers/surveyLookAndFeelHelper"
import * as cloneDeep from 'lodash/cloneDeep'

var module = angular.module("ResearchKitApplicationModule");

module.value('delegatedOAuthClient', {});

module.directive("webViewStep", ["$timeout", "$window", "$http", "ceUrl", "delegatedOAuthClient", "providerAccountService", "participantDeviceInfoService", "$translate", "WebViewStepFrameUrl",
	function ($timeout, $window, $http, ceUrl, delegatedOAuthClient, providerAccountService, participantDeviceInfoService, $translate, WebViewStepFrameUrl) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			},
			link: function (scope, iElement, iAttrs, controller) {

				var iFrame = $(iElement).find("iframe");
				var stepCompleted = false;

				var resetFrameHeight = function () {
					var position = iFrame.position();
					var targetHeight = $(iElement).parents(".current-survey-content").height() - position.top;
					iFrame.height(targetHeight);
				};

				if (scope.stepManager.surveyManager.getMode() !== "Design") {
					$($window).on("resize", resetFrameHeight);
				}

				$window.addEventListener("message", webViewMessageHandler);

				scope.$on("$destroy", function () {
					$window.removeEventListener("message", webViewMessageHandler);
				});

				scope.$on("connectExternalAccountDidFinish", function (event, parameters) {
					iFrame[0].contentWindow.postMessage({ action: event.name, messageID: parameters.messageID, success: parameters.success, errorMessage: parameters.errorMessage }, scope.frameUrl);
				});

				// HACK - See AppActionHandler setActionResult
				appActionHandler?.onMessageReceived(function (message) {
					iFrame?.[0]?.contentWindow?.postMessage(message, scope.frameUrl);
				});

				function webViewMessageHandler(event) {

					if (!acceptableEventSource(event))
						return;

					if (event.data && event.data.name === "RKStudioWebViewStepAnswer" || event.data.name === "CompleteStep") {
						if (!stepCompleted) {
							stepCompleted = true;
							scope.$apply(function () {
								scope.stepManager.childResults = [{
									Identifier: scope.stepManager.step.identifier,
									Type: "WebViewStepResult",
									StartDate: scope.stepManager.presentedDate,
									Result: event.data.answer
								}];
								scope.stepManager.continue();
							});
						}
					}
					else if (event.data && (event.data.name === "GetAccessToken" || event.data.name === "GetDelegatedAccessToken")) {
						scope.$apply(function () {
							if (scope.stepManager.surveyManager.participantID) {
								if (delegatedOAuthClient.standaloneMode) {
									return;
								}
								$http({
									method: 'POST',
									url: ceUrl.make('identityserver/connect/token'),
									data: $.param({
										grant_type: "delegated_participant",
										participant_id: scope.stepManager.surveyManager.participantID,
										client_id: delegatedOAuthClient.ClientID,
										client_secret: delegatedOAuthClient.ClientSecret,
										scope: "api user/*.read",
										token: appActionHandler.isEmbedded ? appActionHandler.token.access_token : undefined
									}),
									headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
								}).then(function (response) {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: response.data, messageID: event.data.messageID, baseUrl: $window.location.origin + ceUrl.getRoot() }, scope.frameUrl);
								}).catch(function () {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: false, message: "Unable to retrieve access token", messageID: event.data.messageID }, scope.frameUrl);
								});
							}
							else {
								iFrame[0].contentWindow.postMessage({ action: event.data.name, success: false, message: "Access token unavailable in this survey mode", messageID: event.data.messageID }, scope.frameUrl);
							}
						});
					} else if (event.data && event.data.name === "DeleteProviderAccount") {
						scope.$apply(function () {
							providerAccountService.promptForAccountRemoval(event.data, iFrame[0].contentWindow, scope.frameUrl);
						});
					} else if (event.data && event.data.name === "ConnectExternalAccount") {
						scope.$apply(function () {
							if (!appActionHandler.isEmbedded) {
								providerAccountService.connectExternalAccount(
									event.data.externalAccountProviderID,
									null,
									event.data.messageID,
									event.data.openNewWindow,
									event.data.width,
									event.data.height);
							} else {
								appActionHandler.connectExternalAccount(event.data.externalAccountProviderID, { openNewWindow: event.data.openNewWindow, width: event.data.width, height: event.data.height }).then(function () {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, messageID: event.data.messageID }, scope.frameUrl);
								}).catch(function (error) {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: false, errorMessage: error, messageID: event.data.messageID }, scope.frameUrl);
								});
							}
						});
					}
					else if (event.data && (event.data.name === "GetDeviceInfo")) {
						scope.$apply(function () {
							if (!appActionHandler.isEmbedded) {
								var deviceInfo = participantDeviceInfoService.getDeviceInfo();
								iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: deviceInfo, messageID: event.data.messageID }, scope.frameUrl);
							} else {
								appActionHandler.getDeviceInfo().then(function (deviceInfo) {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: deviceInfo, messageID: event.data.messageID }, scope.frameUrl);
								})
							}
						});
					}
					else if (event.data && (event.data.name === "ShowParticipantWebVisualizationPDF")) {
						scope.$apply(function () {
							if (!appActionHandler.isEmbedded) {
								scope.$apply(function () {
									scope.$emit("performAction", {
										type: "ShowParticipantWebVisualizationPDF",
										parameters: event.data,
										patientID: scope.stepManager.surveyManager.participantID
									});
								});
							} else {
								appActionHandler.showParticipantWebVisualizationPDF(event.data);
							}
						});
					}
					else if (event.data && (event.data.name === "GetStepConfiguration")) {
						scope.$apply(function () {

							var combinedStyles = angular.extend({}, scope.stepManager.surveyManager.template.styles, scope.stepManager.step.styles);
							var stepConfig = {
								styles: combinedStyles,
								properties: scope.stepManager.step.properties
							};

							iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: stepConfig, messageID: event.data.messageID }, scope.frameUrl);
						});
					}
					else if (event.data && (event.data.name === "GetSurveyContext")) {
						scope.$apply(function () {

							var surveyContext = {
								surveyMode: scope.stepManager.surveyManager.getMode()
							};

							iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: surveyContext, messageID: event.data.messageID }, scope.frameUrl);
						});
					}
					else if (event.data && (event.data.name === "GetCurrentSurveyAnswers")) {
						scope.$apply(function () {
							var surveyAnswers = buildCurrentSurveyAnswers();
							iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: surveyAnswers, messageID: event.data.messageID }, scope.frameUrl);
						});
					}
					else if (event.data && (event.data.name === "RequestSensorKitAuthorization")) {
						appActionHandler.requestSensorKitAuthorization(event.data);
					}
					else if (event.data && (event.data.name === "OpenEmbeddedUrl")) {
						if (appActionHandler.isEmbedded) {
							appActionHandler.openEmbeddedUrl(event.data.url);
						} else {
							window.open(event.data.url, "_blank");
						}
					}
					else if (event.data && (event.data.name === "OpenExternalUrl")) {
						if (appActionHandler.isEmbedded) {
							appActionHandler.openExternalUrl(event.data.url);
						} else {
							window.open(event.data.url, "_blank");
						}
					}
				}

				function updateFrameUrl() {
					var language = $translate.use();
					var tempUrl = (scope.stepManager.step.url ? scope.stepManager.step.url : WebViewStepFrameUrl);
					if (language) {
						if (tempUrl.indexOf('?') >= 0) {
							tempUrl += `&lang=${language}`;
						} else {
							tempUrl += `?lang=${language}`;
						}
					}
					try {
						var checkUrl = new URL(tempUrl)
						if (_.contains(["http:", "https:"], checkUrl.protocol)) {
							scope.frameUrl = checkUrl.href;
						}
					} catch {
						// ignore invalid url
					}
				}

				function acceptableEventSource(event) {
					if (!scope.frameUrl) return false;
					var frameUrl = new URL(scope.frameUrl);
					var originUrl = new URL(event.origin);
					if (originUrl.hostname !== frameUrl.hostname)
						return false;

					if (iFrame.length && event.source === iFrame[0].contentWindow) {
						return true;
					}

					return false;
				}

				function getStepHtml() {
					function escapeHtml(html) {
						var text = document.createTextNode(html);
						var p = document.createElement('p');
						p.appendChild(text);
						return p.innerHTML;
					}

					if (scope.stepManager.step.templateIdentifier) {
						var surveyTemplate = scope.stepManager.surveyManager.template;
						var stepTemplate = _.find(surveyTemplate.webViewStepTemplates, function (t) {
							return t.identifier == scope.stepManager.step.templateIdentifier;
						});
						var html = stepTemplate.html;
						for (var i = 0; i < stepTemplate.fields.length; i++) {
							var fieldIdentifier = stepTemplate.fields[i].identifier;

							var value = scope.stepManager.step.fieldValues[fieldIdentifier];
							if (!value) {
								value = stepTemplate.fields[i].defaultValue ? stepTemplate.fields[i].defaultValue : "";
							}
							if (stepTemplate.fields[i].editorType != "html") {
								value = escapeHtml(value);
							}
							html = html.replace(new RegExp("<%\\s*TemplateField." + fieldIdentifier + "\\s*%>", "g"), value);
						}
						return html;
					} else {
						return scope.stepManager.step.html;
					}
				}

				function populateLegacyAnswerAndChoicesForQuestionSteps(taskResult) {
					if (!taskResult || !taskResult.StepResults) {
						return taskResult;
					}

					var clonedTaskResult = cloneDeep(taskResult);

					for (var i = 0; i < clonedTaskResult.StepResults.length; i++) {
						var stepResult = clonedTaskResult.StepResults[i];
						var step = scope.stepManager.surveyManager.template.steps.find( function (s) {
							return s.identifier === stepResult.Identifier;
						});

						if (!step || step.type !== "QuestionStep" || !stepResult.QuestionResults) {
							continue;
						}

						for (var k = 0; k < stepResult.QuestionResults.length; k++) {
							var questionResult = stepResult.QuestionResults[k];
							if (!questionResult || questionResult.Type !== "QuestionResult") {
								continue;
							}

							var answers = questionResult.Answers;
							questionResult.Answer = answers[0] || "";
							questionResult.Choices = answers;
						}
					}

					return clonedTaskResult;
				}

				function buildCurrentSurveyAnswers() {

					var taskResult = scope.stepManager.surveyManager.getResult();
					var surveyAnswers = [];
					const validStepTypes = ["QuestionStep", "FormStep", "WebViewStep", "ConsentReviewStep"];

					for (var i = 0; i < taskResult.StepResults.length; i++) {

						var stepResult = taskResult.StepResults[i];
						var step = _.find(scope.stepManager.surveyManager.template.steps, function (s) {
							return s.identifier === stepResult.Identifier && _.contains(validStepTypes, s.type);
						});
						if (!step) continue;

						for (var k = 0; k < stepResult.QuestionResults.length; k++) {

							var questionResult = stepResult.QuestionResults[k];
							var surveyAnswer = {
								date: questionResult.EndDate,
								stepIdentifier: stepResult.Identifier,
								resultIdentifier: questionResult.Identifier,
								answers: []
							}
							if (step.type === "ConsentReviewStep") {
								surveyAnswer.consented = questionResult.Consented;
								surveyAnswer.givenName = questionResult.Signature?.GivenName;
								surveyAnswer.familyName = questionResult.Signature?.FamilyName;
							}

							_.each(questionResult.Answers, function (answer) { surveyAnswer.answers.push(answer); })
							if (questionResult.Result) surveyAnswer.answers.push(questionResult.Result);

							surveyAnswers.push(surveyAnswer);
						}
					}

					return surveyAnswers;
				}

				function getCssVariableOverrides() {
					var styleSettings = angular.extend({}, scope.stepManager.surveyManager.template.styles, scope.stepManager.step.styles);
					var styleVars = makeCssVars(styleSettings);
					return styleVars.length ? `<style>:root { ${styleVars} }</style>` : "";
				}

				function reloadFrame() {
					var frameParent = iFrame.parent();
					iFrame.remove();
					iFrame = frameParent.append(frameElementDefinition);
					iFrame = $(frameParent).find("iframe");
					resetFrameHeight();

					let mode = scope.stepManager.step.contentMode || (scope.stepManager.step.url ? "specifyUrl" : "fullHtml");

					updateFrameUrl();

					let webContent = getStepHtml();

					if (mode === "partialHtml") {
						webContent = webViewStructuredHtml.replace(/{\s?html\s?}/g, webContent);
						webContent = webContent.replace(/{\s?cssVariableOverrides\s?}/g, getCssVariableOverrides());
					}

					let prependContent = webViewContent;
					let taskResult = populateLegacyAnswerAndChoicesForQuestionSteps(scope.stepManager.surveyManager.getResult());
					let taskResultEncoded = _.escape(JSON.stringify(taskResult));
					prependContent = prependContent.replace(/{\s?taskResult\s?}/g, taskResultEncoded);
					let baseUrlEncoded = _.escape($window.location.protocol + "//" + $window.location.host + ceUrl.make("/"));
					prependContent = prependContent.replace(/{\s?baseUrl\s?}/g, baseUrlEncoded);
					webContent = prependContent + webContent;

					iFrame.off("load");
					iFrame.on("load", function () {
						this.contentWindow.postMessage({ name: "RKStudioStepContent", content: webContent }, scope.frameUrl);
					});
					iFrame.attr("src", scope.frameUrl);

					stepCompleted = false;
				}

				var reloadFrameDebounce = _.debounce(function () {
					reloadFrame();
				}, 50);

				scope.$watch("stepManager.step.html", reloadFrameDebounce);
				scope.$watch("stepManager.step.fieldValues", reloadFrameDebounce, true);
				scope.$watch("stepManager", reloadFrameDebounce);
				scope.$watch("stepManager", function () {
					if (scope.stepManager.surveyManager.getMode() !== "Design") {
						$timeout(resetFrameHeight, 0, false);
					}
				});

				let iframeSandboxAttributes = function () {
					let attributes = "allow-forms allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"
					if (appActionHandler.isEmbedded) {
						attributes += " allow-top-navigation-by-user-activation"
					}
					return attributes;
				}

				const frameElementDefinition = `<iframe allowfullscreen src="" tabindex="0" style="border: none; padding: 0; margin: 0; width: 100%; display: block;" sandbox="${iframeSandboxAttributes()}" allow="camera; microphone; clipboard-write"></iframe>`;
			}
		};
	}]
);